import { CoreDataSecurityApplicationsName } from './name';
import { getCoreDataSecurityApplicationsAllSlice } from './all/get';
import { unhideDataSecurityApplicationById } from '@api/data-security';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const unhideCoreDataSecurityApplicationsSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.APPLICATION_MODIFIED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			() => getCoreDataSecurityApplicationsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityApplicationsAll()
		]
	},
	name: CoreDataSecurityApplicationsName,
	receive: false,
	request: true,
	requestHandler: unhideDataSecurityApplicationById
});
